import { numberUtils } from '@pukka/common/utils';
import { Shimmer, Text } from '@pukka/ui-components';

interface BillingPriceSummaryDiscountProps {
  readonly loading?: boolean;
  readonly price?: number;
  readonly description?: string;
}

function BillingPriceSummaryDiscount({ loading, price, description }: BillingPriceSummaryDiscountProps) {
  return (
    <div className="text-right">
      {/* eslint-disable-next-line no-nested-ternary */}
      {price !== undefined ? (
        loading ? (
          <Shimmer size="sm" className="ml-auto" />
        ) : (
          <Text variant="caption-1" className="text-red-500 line-through">
            Rp {numberUtils.formatCurrency(price)}
          </Text>
        )
      ) : null}
      {/* eslint-disable-next-line no-nested-ternary */}
      {description ? (
        loading ? (
          <Shimmer size="sm" className="ml-auto mt-1.5" />
        ) : (
          <Text variant="caption-1" className="whitespace-pre text-green-500">
            {description}
          </Text>
        )
      ) : null}
    </div>
  );
}

export { BillingPriceSummaryDiscount };
